import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Box, Container, Alert, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
//
import { AppContext } from '/@/app/AppContext';
import { ScrollContext } from '/@/app/AppLayout';
import { route } from '/@/app/routes';
import { StepInfoBlock } from '/@/app/components/StepInfoBlock';
import { filterOutLifeExpectancy } from '/@/app/views/RisksView/lifeExpectancyFilter';
import { RiskItem } from '/@/app/views/RisksView/RiskItem';
import { PaywallBlock, ExpireBlock } from '/@/app/components/Paywall'
import { UpdateAnnouncements } from '/@/app/components/UpdateAnnouncements';
import { AudioPlayer } from '/@/app/components/AudioPlayer';
import { userFlowState } from '/@/app/states/userFlowState';
import { useApi} from '/@/app/Api';


export const RisksView = () => {
const api=useApi();
const {restoreScroll}=useContext(ScrollContext);
    const { bootstrapData } = useContext(AppContext);
    const { user_flow } = useContext(AppContext).bootstrapData;
    const { help } = useContext(AppContext).bootstrapData;
    const { t,i18n } = useTranslation();

    const [risks,setRisks] =useState(null);
    const [meta,setMeta] =useState(null);

useEffect(() =>
{
	api.request('cabinet/risks',{panel_id:bootstrapData.panel.id},{api_url:'v2'})
	.then(re=>{ setMeta(re[0]); setRisks(re.slice(1)); });
}, []);

useEffect(() =>
{
	if (!risks) return;
	restoreScroll();
}, [risks]);

if (!risks) return (<></>);


    userFlowState.markRisksVisited();

    return (
        <Container maxWidth="sm">
            <Box>
                <AudioPlayer audioSrc={help.sounds['risks-'+i18n.language]} sx={{ mb: 1, mr: 2, ml: 1, float: "right" }} />
                <Typography variant="h3" gutterBottom>{t("Риски")}</Typography>
            </Box>
            <Container maxWidth="sm" className="home-view-centered-content">
                <UpdateAnnouncements mode="silent"/>
            </Container>

            {!userFlowState.allQuestionsAnswered ?
                <Alert severity="warning">
		    {t("flow-warning-answer")} <ReactRouterLink to={route("/questions/")}>{t("вопросы")}</ReactRouterLink>{" "}
		    {t("и заполните")} <ReactRouterLink to={route("/lab-tests/")}>{t("данные анализов")}</ReactRouterLink>,
		    {t("чтобы узнать ваши риски")}.
                </Alert>
                :
                <>
                    {userFlowState.globalPanel.last_calculated_at !== null &&
                        <>
                            {risks.length === 0 ?
                                <Alert severity="info">{t("У Вас нет выявленных рисков.")}</Alert>
                                :
                                <Grid container spacing={2} >
                                    {risks.map((risk, stepIndex) => (
					risk.expire_block ?  (<ExpireBlock data={risk}/>) :(
                                        <Grid item xs={12} key={stepIndex}>
					    { risk.paywall_block?<PaywallBlock data={risk}/>:<RiskItem risk={risk} /> }
                                        </Grid>)
                                    ))}
                                </Grid>
                            }
                        </>
                    }
                </>
            }

            <StepInfoBlock text={ help.texts['risks-footer-'+i18n.language] } />
        </Container>
    );
};
